import { GoogleTagManagerConfiguration } from '../app/util/tracking/google-analytics/google-tag.interfaces';

const backendUri =
  'https://skillz-beehive-cghhejhpfpeahhan.westeurope-01.azurewebsites.net';
const frontendUri = 'https://skillz.be';

export const environment = {
  production: false,
  auth: {
    domain: 'login.skillz.be',
    clientId: 'uir3TDDjumdlSfWM9kvAAKP3c8s5UyKD',
    authorizationParams: {
      audience: 'https://api.skillz.be/',
      redirect_uri: window.location.origin,
    },
  },
  franchise: {
    name: 'Skillz vzw',
    bankAccountNumber: 'BE94731048571814',
  },
  backendUri,
  frontendUri,
  backofficeUrl: frontendUri,
  rollbar: {
    enabled: true,
    accessToken: 'c309d08ddf894a64a21a162bd9461374',
    captureUncaught: true,
    captureUnhandledRejections: true,
    environment: 'production',
    payload: {
      environment: 'production',
      client: {
        javascript: {
          source_map_enabled: true,
          code_version: '1.0.0',
          guess_uncaught_frames: true,
        },
      },
    },
  },
  recaptcha: {
    siteKey: '6Le5Ak8qAAAAAL9jtsqWs2urf_CrUYhyf_jGPonx',
  },
  googlePlaces: {
    apiKey: 'AIzaSyAikdAzjhMCUooReiuKdqoRN0D31n59C_w',
  },
  googleTagManager: {
    containerId: 'GTM-WZKBNX38',
    authentication: '_CybLqZ_fOZVpOR3OAAvIg',
    preview: 'env-1',
    cookies: 'x',
  } as const satisfies GoogleTagManagerConfiguration,
  uitDatabase: {
    taxonomyUrl: 'https://taxonomy.uitdatabank.be/terms',
    entryUrl: 'https://io.uitdatabank.be',
    searchUrl: 'https://search.uitdatabank.be',
    auth: {
      clientId: '1ddd7858-fb5e-46f4-adbf-3764566db0ae',
    },
  },
};
